import GitHubIcon from "@mui/icons-material/GitHub";
import GroupIcon from "@mui/icons-material/Group";
import LinkIcon from "@mui/icons-material/Link";
import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { Box, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import projectsJSON from "../data/projects.json";
import Pin from "./Pin";

export default function Projects(props) {
  const projects = projectsJSON.Projects;
  const isMobile = useMediaQuery("(max-width: 700px)");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              width: 4,
              height: 24,
              background: "#85e0ff",
              borderRadius: "2px",
              flexShrink: 0,
            }}
          />
          <Typography
            component="h5"
            variant="h5"
            color="primary"
            sx={{ fontFamily: "Roboto", fontWeight: 700 }}
          >
            Projects
          </Typography>
        </Box>
      </Box>
      <Box>
        <Timeline
          position={isMobile ? "right" : "alternate"}
          sx={
            isMobile
              ? {
                  "& .MuiTimelineItem-root::before": { flex: 0, padding: 0 },
                  "& .MuiTimelineSeparator-root": {
                    width: "40px",
                    alignItems: "center",
                  },
                }
              : {}
          }
        >
          {projects.map((project, i) => {
            let icon1 = <GitHubIcon fontSize="small" />;
            let icon2 = null;
            if (project.URL) {
              icon1 = <LinkIcon fontSize="small" />;
            }
            if (project.Group) {
              icon2 = (
                <>
                  <GroupIcon fontSize="small" /> {project.Group}
                </>
              );
            }
            return (
              <TimelineItem key={i}>
                <TimelineSeparator>
                  <TimelineDot
                    variant="default"
                    style={{ backgroundColor: "#85e0ff", border: "none" }}
                  />
                  <TimelineConnector
                    style={{ backgroundColor: "rgba(133,224,255,0.50)" }}
                  />
                </TimelineSeparator>
                <TimelineContent>
                  <Pin
                    index={i}
                    title={project.Title}
                    subheading={project?.Prize}
                    startDate={project.StartDate}
                    desc1={project.Technologies}
                    desc2={
                      <>
                        <a
                          href={project.URL ? project.URL : project.Github}
                          style={{
                            color: "inherit",
                            textDecoration: "none",
                            marginRight: "2px",
                          }}
                        >
                          {icon1}
                        </a>
                        {icon2}
                      </>
                    }
                    desc3={project.Description}
                    isMobile={isMobile}
                  />
                </TimelineContent>
              </TimelineItem>
            );
          })}
        </Timeline>
      </Box>
    </Box>
  );
}
